module.exports = __webpack_public_path__ + "static/media/banner.5160c0f1.png";